import api from '../../../services/api';
import { useState, useEffect } from "react";
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import icone_administrativo from '../../../assets/a.png';
import icone_servico from '../../../assets/s.png';
import icone_vendas from '../../../assets/v.png';
import icone_manutencaom from '../../../assets/mm.png';
import icone_manutencaov from '../../../assets/mv.png';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';

function SetorOpcoes() {
    const [setor, setSetor] = useState(null);
    const { id } = useParams();

    const icones = {
        administrativo: icone_administrativo,
        servico: icone_servico,
        vendas: icone_vendas,
        manutencaomecanica: icone_manutencaom,
        manutencaoveicular: icone_manutencaov,
    };

    const normalizeName = (name) => {
        return name
            .toLowerCase()
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/\s+/g, '');
    };

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/setor/${id}`);
                setSetor(response.data);
            } catch (error) {
                console.error('Erro ao buscar o setor:', error);
            }
        }
        fetchData();
    }, [id]);

    if (!setor) {
        return (
            <PageContainer>
                <Typography color="text.secondary">Carregando...</Typography>
            </PageContainer>
        );
    }

    const setorIcone = setor.nome ? icones[normalizeName(setor.nome)] : null;

    return (
        <PageContainer>
            <PageHeader title={setor.nome || 'Setor'} />

            {setorIcone && (
                <Box
                    component="img"
                    src={setorIcone}
                    alt={setor.nome}
                    sx={{ height: 100, display: 'block', mx: 'auto', mb: 3 }}
                />
            )}

            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea component={Link} to={`/setor/${setor.id}/custoFixo`} sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <PaidOutlinedIcon color="primary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Custo Fixo</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <Card>
                        <CardActionArea component={Link} to={`/setor/${setor.id}/custoVariavel`} sx={{ p: 3 }}>
                            <CardContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                                <TrendingUpOutlinedIcon color="secondary" sx={{ fontSize: 40 }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Custo Variável</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </PageContainer>
    );
}

export default SetorOpcoes;
